import {
  mapper
} from '@shared/lib';
import type {
  BonusConfig,
  ChestWithBonuses,
  BonusConfigMedia,
} from '../model';

type MapBonusConfigMedia = (data: any) => BonusConfigMedia;
export const mapBonusConfigMedia: MapBonusConfigMedia = mapper([{
  name: 'url',
  transform: (urlData: Maybe<Url>) => urlData ?? null
}]);

export const mapChestConfig: MapChestConfig = mapper([
  { name: 'id' },
  { name: 'active' },
  { name: 'repeat' },
  { name: 'steps' },
  { name: 'purchaseBonuses' },
  { name: 'purchaseButtonText' },
  { name: 'rewardBonusesCount' },
  { name: 'rewardButtonTextClaimed' },
  { name: 'title', from: 'chestTitle' },
  { name: 'rewardButtonTextUnclaimed' },
  {
    name: 'purchasesBonusPlanId',
    transform: (purchasesBonusPlanId: string) => {
      return parseInt(purchasesBonusPlanId)
    },
  },
  { name: 'claimProgressText' },
  {
    name: 'closedChestImg',
    transform: (closedChestImgData: Maybe<Url>) => mapBonusConfigMedia(closedChestImgData)
  },
  {
    name: 'openedChestImg',
    transform: (openedChestImgData: Maybe<Url>) => mapBonusConfigMedia(openedChestImgData)
  },
  { name: 'redeemableCoinAmount' },
  { name: 'nonRedeemableCoinAmount' },
  { name: 'endDate' },
]);

type MapBonusConfig = (data: any) => BonusConfig;
export const mapBonusConfig: MapBonusConfig = mapper([
  { name: 'title', from: 'bonusConfiguration.title' },
  { name: 'link', from: 'bonusConfiguration.link' },
]);

type MapChestConfig = (data: unknown) => ChestWithBonuses;
export const mapChestsConfig = (data: any) => {
  return data?.treasureChests?.map(mapChestConfig) as ChestWithBonuses[];
};